import instance from '../api';
import { message } from 'antd';
import { ErrorNotification } from '../../Utils/data';

export const newAccount = {
  async read(
    userName: string,
    userEmail: string,
    company: string | number,
    skip: string | number = 1,
    isEmailVerified?: boolean,
  ) {
    const { data } = await instance(
      `users/registered-users?page=${skip}&perPage=10&searchName=${userName}&searchEmail=${userEmail}&searchCompany=${encodeURIComponent(
        company,
      )}&isEmailVerified=${isEmailVerified}`,
    );
    return {
      data: data.data,
      count: data.count,
    };
  },
  async updateUserStatus(
    userName: string,
    userEmail: string,
    company: string | number,
    skip: string | number = 1,
    registerStatus?: string,
  ) {
    const { data } = await instance(
      `users/registered-users?registerStatus=${registerStatus}&page=${skip}&perPage=10&searchName=${userName}&searchEmail=${userEmail}&searchCompany=${company}`,
    );
    return {
      data: data.data,
      count: data.count,
    };
  },
  async approvalPatch(id: any, body: any) {
    const key = 'updatable';
    message.loading({ content: 'Loading...', key });

    try {
      const { data }: { data: any } = await instance(`users/register-edit/${id}`, {
        method: 'PATCH',
        data: body,
      }).then((u) => {
        setTimeout(() => {
          message.success({ content: 'Loaded!', key, duration: 2 });
        }, 1000);
        return u;
      });
      return data;
    } catch (error: any) {
      ErrorNotification({
        status: error.response.status,
        message: error.response.data.error.message,
      });
    }
  },
  async approvalCount() {
    const isAuthenticated = localStorage.getItem('token') as string;
    if (isAuthenticated) {
      const { data }: any = await instance(`users/register-count`);
      return {
        data: data.data,
        count: data.count,
      };
    }
  },
  async resendEmail(body: { email: string }) {
    message.loading({ content: 'Sending email...' });
    try {
      const { data } = await instance.post('/auths/resend-email', body);
      message.success({ content: 'Email resent successfully!', duration: 2 });
      return data;
    } catch (error: any) {
      ErrorNotification({
        status: error?.response?.status,
        message: error?.response?.data?.error?.message || 'Something went wrong!',
      });
    }
  },
  async unReadEmail() {
    const { data } = await instance.get('/users/registered-users');

    return {
      data: data.data,
      count: data.count,
      emailNotVerifiedUsersCount: data.emailNotVerifiedUsersCount,
      emailVerifiedUsersCount: data.emailVerifiedUsersCount,
    };
  },
};
